// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.round-tabs-container {
  margin: 40px 0 0 0;
}

.header-container {
  display: flex;
  justify-content: space-between;
}
.header-container .month {
  border-radius: 5px 5px 0 0;
  border-top: 1px solid #A7A9AC;
  border-left: 1px solid #A7A9AC;
  border-right: 1px solid #A7A9AC;
  color: #0A4064;
  background: #C0DEF0;
  padding: 3px 0;
  font-size: 0.9rem;
  font-weight: 500;
  text-align: center;
  width: 100%;
}
.header-container .special {
  min-width: 220px !important;
  width: 220px;
  max-width: 220px;
}

.action-container {
  display: flex;
  align-items: center;
  height: 35px;
}
.action-container .action-window-container {
  border-right: 2px solid #D1D3D4;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  font-size: 0.8rem;
  min-width: 220px !important;
  width: 220px;
  max-width: 220px;
  height: 100%;
  padding: 0 10px;
}
.action-container .action-data-container {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}
.action-container .action-data-container .window-pre {
  display: flex;
  justify-content: flex-end;
  font-size: 0.85rem;
  font-size: 0.7rem;
  font-style: italic;
}
.action-container .action-data-container .window-post {
  background: rgb(130, 206, 231);
  font-size: 0.7em;
}

.stripe {
  background-color: #EDf0F1;
}

.tooltip-window > .tooltip-inner {
  background-color: #444343;
  opacity: 1;
  max-width: 100%;
}

.tool-tip-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
}
.tool-tip-container span {
  font-weight: 500;
  padding: 5px 0;
}

.school-year {
  display: flex;
  align-items: center;
  border-top: 1px solid #D1D3D4;
}
.school-year .yellow {
  margin-top: 5px;
  margin-bottom: 5px;
  border-radius: 5px;
  font-size: 0.87rem;
  font-weight: 500;
  padding: 5px 15px;
  background: #FEBF31;
}
.school-year span {
  font-weight: 500;
}

.round1-class {
  border-radius: 3px;
  cursor: pointer;
  background: #9acdd2;
  border: 1px solid #75c2c9;
  height: 30px;
  margin-right: 5px;
}

.round2-class {
  border-radius: 3px;
  cursor: pointer;
  background: #bca0d3;
  border: 1px solid #946eb4;
  height: 30px;
}

.date-placement {
  font-weight: 500;
  white-space: nowrap;
  margin-left: 10px;
  font-size: 0.7rem;
  font-style: italic;
}

.round2-date-placement {
  font-weight: 500;
  font-size: 0.7rem;
  font-style: italic;
  text-align: right;
  margin-right: 10px;
  white-space: nowrap;
}

@media only screen and (max-width: 850px) {
  .date-placement {
    display: inline-block;
    font-size: 0.5rem;
  }
  .round2-date-placement {
    display: inline-block;
    font-size: 0.5rem;
  }
}
@media only screen and (max-width: 920px) {
  .date-placement {
    display: inline-block;
    font-size: 0.6rem;
  }
  .round2-date-placement {
    display: inline-block;
    font-size: 0.6rem;
  }
}
@media only screen and (max-width: 1260px) {
  .date-placement {
    display: inline-block;
    font-size: 0.6rem;
  }
  .round2-date-placement {
    display: inline-block;
    font-size: 0.6rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/Timeline.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,kBAAA;AAUJ;;AARA;EACI,aAAA;EACA,8BAAA;AAWJ;AAVI;ECNA,0BDO0B;EACtB,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,cDCE;ECAF,mBDWI;ECVJ,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAYR;AAVI;EACI,2BAAA;EACA,YAAA;EACA,gBAAA;AAYR;;AATA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;AAYJ;AAVI;EACI,+BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAYR;AAVI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAYR;AAVQ;EACI,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAYZ;AAVQ;EACI,8BAAA;EACA,gBAAA;AAYZ;;AARA;EACI,yBDhDI;AC2DR;;AARA;EACI,yBD9CK;EC+CL,UAAA;EACA,eAAA;AAWJ;;AARA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;AAWJ;AAVI;EACI,gBAAA;EACA,cAAA;AAYR;;AARA;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;AAWJ;AAVI;EACI,eAAA;EACA,kBAAA;ECzFJ,kBD0F0B;EACtB,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBDjFI;AC6FZ;AAVI;EACI,gBAAA;AAYR;;AARA;ECrGI,kBDsGsB;EACtB,eAAA;EACA,mBDzEc;EC0Ed,yBAAA;EACA,YAAA;EACA,iBAAA;AAWJ;;AATA;EC7GI,kBD8GsB;EACtB,eAAA;EACA,mBD9EU;EC+EV,yBAAA;EACA,YAAA;AAYJ;;AAVA;EACI,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAaJ;;AAXA;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAcJ;;AAVA;EACI;IACI,qBAAA;IACA,iBAAA;EAaN;EAXE;IACI,qBAAA;IACA,iBAAA;EAaN;AACF;AAVA;EACI;IACI,qBAAA;IACA,iBAAA;EAYN;EAVE;IACI,qBAAA;IACA,iBAAA;EAYN;AACF;AATA;EACI;IACI,qBAAA;IACA,iBAAA;EAWN;EATE;IACI,qBAAA;IACA,iBAAA;EAWN;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n$lt-blue: #7DB7CC;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n$DCSD-logo-green: #84ae30;\n$dashboard-blue: #0d6efd;\n$dk-blue: #0A4064;\n$important: #FEBF31;\n$highlight: #FDF9D0;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$grey5: #333;\n$pale-blue: #C0DEF0;\n$pearl-dk-blue: #0762a7;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$teal-logo: #46A8B0;\n\n$pale-blue-green: #9acdd2;\n$pale-blue-green-outline: #75c2c9;\n\n$pale-purple: #bca0d3;\n$pale-purple-outline: #946eb4;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.round-tabs-container {\n    margin: 40px 0 0 0;\n}\n.header-container {\n    display: flex;\n    justify-content: space-between;\n    .month {\n        @include borderRadius(5px 5px 0 0);\n        border-top: 1px solid $grey2;\n        border-left: 1px solid $grey2;\n        border-right: 1px solid $grey2;\n        color: $dk-blue;\n        background: $pale-blue;\n        padding: 3px 0;\n        font-size: 0.9rem;\n        font-weight: 500;\n        text-align: center;\n        width: 100%;\n    }\n    .special {\n        min-width: 220px !important;\n        width: 220px;\n        max-width: 220px;\n    }\n}\n.action-container {\n    display: flex;\n    align-items: center;\n    height: 35px;\n\n    .action-window-container {\n        border-right: 2px solid $grey1;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        font-weight: 500;\n        font-size: .8rem;\n        min-width: 220px !important;\n        width: 220px;\n        max-width: 220px;\n        height: 100%;\n        padding: 0 10px;\n    }\n    .action-data-container {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        height: 100%;\n\n        .window-pre {\n            display: flex;\n            justify-content: flex-end;\n            font-size: .85rem;\n            font-size: .7rem;\n            font-style: italic\n        }\n        .window-post {\n            background: rgb(130, 206, 231);\n            font-size: .7em;\n        }\n    }\n}\n.stripe {\n    background-color: $grey0;\n}\n\n.tooltip-window > .tooltip-inner {\n    background-color: $grey4a;\n    opacity: 1;\n    max-width: 100%;\n}\n\n.tool-tip-container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 20px;\n    span {\n        font-weight: 500;\n        padding: 5px 0;\n    }\n}\n\n.school-year {\n    display: flex;\n    align-items: center;\n    border-top: 1px solid $grey1;\n    .yellow {\n        margin-top: 5px;\n        margin-bottom: 5px;\n        @include borderRadius(5px);\n        font-size: .87rem;\n        font-weight: 500;\n        padding: 5px 15px;\n        background: $important;\n    }\n    span {\n        font-weight: 500;\n    }\n}\n\n.round1-class {\n    @include borderRadius(3px);\n    cursor: pointer;\n    background: $pale-blue-green;\n    border: 1px solid $pale-blue-green-outline;\n    height: 30px;\n    margin-right: 5px;\n}\n.round2-class {\n    @include borderRadius(3px);\n    cursor: pointer;\n    background: $pale-purple;\n    border: 1px solid $pale-purple-outline;\n    height: 30px;\n}\n.date-placement {\n    font-weight: 500;\n    white-space: nowrap;\n    margin-left: 10px;\n    font-size: .7rem;\n    font-style: italic;\n}\n.round2-date-placement {\n    font-weight: 500;\n    font-size: .7rem;\n    font-style: italic;\n    text-align: right;\n    margin-right: 10px;\n    white-space: nowrap;\n}\n\n// ------------ 850px --------------------\n@media only screen and (max-width: 850px) {\n    .date-placement {\n        display: inline-block;\n        font-size: 0.5rem;\n    }\n    .round2-date-placement {\n        display: inline-block;\n        font-size: 0.5rem;\n    }\n}\n// ------------ 920px --------------------\n@media only screen and (max-width: 920px) {\n    .date-placement {\n        display: inline-block;\n        font-size: 0.6rem;\n    }\n    .round2-date-placement {\n        display: inline-block;\n        font-size: 0.6rem;\n    }\n}\n// ------------ 1260 px --------------------\n@media only screen and (max-width: 1260px) {\n    .date-placement {\n        display: inline-block;\n        font-size: 0.6rem;\n    }\n    .round2-date-placement {\n        display: inline-block;\n        font-size: 0.6rem;\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
